<template>
  <div>
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column label="新闻标题" width="1096">
        <template slot-scope="scope">
          <div>
            <router-link :to="'/news/desc?id='+scope.row.id"><span>{{ scope.row.title }}</span></router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="日期" width="100">
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import {
    getNews
  } from '@/api/news.js'

  export default {
    name: "NewsMenu",
    data() {
      return {
        tableData: [],
        currentPage: 1,
        total: 0,
        pageSize: 10,
      };
    },
    components: {},
    methods: {
      handleCurrentChange(val) {
        getNews('news/get?page=' +
          val, this);
      },
    },
    created() {
      getNews('news/get?page=1', this);
    }
  }
</script>
<style>
  a {
    text-decoration: none;
  }

  .router-link-active {
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/news/NewsMenu.vue